import { Spacing } from '@genial/design-tokens';
import { Utils, useBreakpointValue } from '@genial/utils';
import React from 'react';
import { ScrollView, StyleSheet, View } from 'react-native';

import { FastTicket } from './components/FastTicket';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingVertical: Utils.Token.ToInt(Spacing, 'inset.sm'),
  },
  containerBase: {
    paddingHorizontal: Utils.Token.ToInt(Spacing, 'inset.sm'),
  },
  contentLg: {
    minWidth: 1280,
    maxWidth: 1280,
    alignSelf: 'center',
  },
});

export const GenialReport: React.FC = () => {
  const responsiveStyleContainer = useBreakpointValue({
    base: styles.containerBase,
    lg: {},
  });

  const responsiveStyleContent = useBreakpointValue({
    base: {},
    lg: styles.contentLg,
  });

  return (
    <ScrollView style={[styles.container, responsiveStyleContainer]}>
      <View style={responsiveStyleContent}>
        <FastTicket />
      </View>
    </ScrollView>
  );
};
